import api from "../api.js";

export const submitEventCoverage = async (payload) => {
  const { data } = await api.post("/event-coverage", payload);
  return data;
};

export const fetchMyCoverages = async () => {
  const { data } = await api.get("/event-coverage/my");
  return data;
};

export const checkEventCoverage = async (eventId) => {
  const { data } = await api.get(`/event-coverage/check/${eventId}`);
  return data;
};
